
import { Row, Col, Modal, Divider, Image, Select, Checkbox, Spin } from "antd";
import React, { useState } from "react";
import { CgPrinter } from "react-icons/cg";
import { useSelector } from "react-redux";
import logo from "../../Assets/Icons/newLogo.png";
import ReactHtmlParser from "react-html-parser";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useMediaQuery } from "react-responsive";
import { Loading } from "../../Common/components/Loading";
const EmailPreview = ({ ispreview, setIspreview, personsArray, RTDInitiator, role, allBuyerAgentData, allSellerAgentData, selectedPersonsState, subjectForm, emailSignatureId, allAgent, emailPreviewClients, source, combinedSameSideAgents, emailPreviewData, emailPreviewLoading }) => {
  const history = useHistory();
  const isSmallScreen = useMediaQuery({ maxWidth: 550 });
  const rowStyle = {
    marginBottom: "12px",
    borderBottom: "1px solid #f0f0f0",
    paddingBottom: "8px",
  };

  const labelStyle = {
    fontWeight: "bold",
    fontSize: "16px",
    color: "#555",
  };

  const valueStyle = {
    fontSize: "15px",
    color: "#000",
  };

  const combinedRecipients = [
    ...(emailPreviewClients?.map((el) => ({
      name: el?.Name,
      role: el?.corpName ? el?.corpName : "",
      clientType: el?.clientType,
      corpName: el?.corpName,
      isCorp: el?.isCorp,
    })) || []),

    ...(selectedPersonsState?.agents && (RTDInitiator === "SELLER" || role === "SELLER")
      ? allBuyerAgentData?.map((el) => ({
          name: el?.fullName,
          role: "Agent",
          clientType: "Agent",
        }))
      : []),

    ...(selectedPersonsState?.agents && (RTDInitiator === "BUYER" || role === "BUYER")
      ? allSellerAgentData?.map((el) => ({
          name: el?.fullName,
          role: "Agent",
          clientType: "Agent",
        }))
      : []),

    ...(selectedPersonsState?.agentsData?.length > 0
      ? selectedPersonsState?.agentsData?.map((el) => ({
          name: el?.fullName,
          role: "Agent",
          clientType: "Agent",
        }))
      : []),

    ...(selectedPersonsState?.titleRepsData?.length > 0
      ? selectedPersonsState?.titleRepsData?.map((el) => ({
          name: el?.fullName,
          clientType: "Title_Company_Rep",
        }))
      : []),

    ...(selectedPersonsState?.affiliatesData?.length > 0
      ? selectedPersonsState?.affiliatesData?.map((el) => ({
          name: el?.fullName,
          clientType: "Title_Company_Affiliate",
        }))
      : []),
  ];

  const handleRedirect = () => {
    history.push({ pathname: "/" });
  };
  return emailPreviewLoading ? (
    <Loading />
  ) : (
    <>
      <div
        style={{
          position: "fixed", // Fix the position
          top: 0, // Stick to the top
          left: 0, // Align to the left
          width: "100%", // Full width
          display: "flex",
          alignItems: "center",
          gap: "10px",
          cursor: "pointer",
          transition: "all .5s ease-in-out",
          backgroundColor: "#124E8F",
          height: "5vh",
          zIndex: 1000, // Ensure it stays above other elements
        }}
      >
        <div style={{ width: "80px", height: "80px", overflow: "hidden", marginLeft: "20px" }}>
          <img src={logo} alt="Re-Sure Logo" onClick={handleRedirect} style={{ width: isSmallScreen ? "40px" : "80px", height: "80px", objectFit: "contain" }} />
        </div>
        <text style={{ color: "white", textAlign: "center", fontSize: isSmallScreen ? "18px" : "24px", width: "100%", fontWeight: "bold" }}>
          Email Preview
          {/* <CgPrinter style={{marginRight: "5px",marginBottom: "-3px",}}/> */}
        </text>
      </div>
      <div style={{ padding: "20px 10%", background: "#fff", marginTop: "5vh" }}>
        {/* Recipients Section */}
        {combinedRecipients?.filter((el) => el?.role !== "Agent").length > 0 && (
          <Row style={rowStyle}>
            <Col span={6} style={labelStyle}>
              Recipients:
            </Col>
            <Col span={18} style={valueStyle}>
              {combinedRecipients
                .filter((el) => el?.role !== "Agent") // Remove items where role is "Agent"
                .map(
                  (el) => (el?.role ? `${el?.name} (${el?.role})` : el?.name) // Include role only if it exists
                )
                .filter(Boolean) // Remove any undefined or empty values
                .join(", ")}
            </Col>
          </Row>
        )}

         {/* Agents Section */}
         {allAgent?.length > 0 && (
  <Row style={rowStyle}>
    <Col span={6} style={labelStyle}>
      Agents:
    </Col>
    <Col span={18} style={valueStyle}>
      {allAgent.map((agent, index) => (
        <span key={index}>
          {agent}
          {index !== allAgent.length - 1 && ", "}
        </span>
      ))}
    </Col>
  </Row>
)}

        <Row style={{ flexDirection: "column" }}>
          {(emailPreviewData || [])?.map((item, index) => {
            const name = item.name;
            const email = item.email;
            const clientType = item.clientType;
            const nameCount = item.name.split(",").map((name) => name.trim()).length;

            return (
              <Col span={24} key={index} style={{ marginTop: "10px" }}>
                {/* Render "To:" format when clientType is "Agent" */}
                {clientType === "Agent" && nameCount > 1 ? (
                  <>
                    <div style={{ fontWeight: "bold", marginBottom: "8px", display: "flex" }}>
                      <text style={{ color: "grey" }}>To:</text>
                      <div style={{ marginLeft: "10px" }}>
                        <text> {name}</text>
                        <br />
                        <text style={{ color: "blue" }}> ({email})</text>
                      </div>
                    </div>
                  </>
                ) : (
                  <div style={{ fontWeight: "bold", marginBottom: "8px" }}>
                    <text style={{ color: "grey", marginRight: "10px" }}>To:</text>
                    <text> {name}</text>
                    <text style={{ color: "blue" }}> ({email})</text>
                  </div>
                )}

                <div style={{ width: "100%", padding: "8px", border: "none", pointerEvents: "none", overflowX: "auto" }} dangerouslySetInnerHTML={{ __html: item[item.name] }} />
                {/* <div style={{ border: "none" }}>{ReactHtmlParser(item[name])}</div>
            </div> */}

                {index < emailPreviewData.length - 1 && <hr style={{ fontWeight: "bold", marginTop: "20px" }} />}
              </Col>
            );
          })}
        </Row>
      </div>
    </>
  );
};

export default EmailPreview;
